import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEN from './locales/en/common.json' with { type: "json" };
import authEN from './locales/en/auth.json' with { type: "json" };
import diagramEN from './locales/en/diagram.json' with { type: "json" };
import genogramEN from './locales/en/genogram.json' with { type: "json" };
import errorsEN from './locales/en/errors.json' with { type: "json" };
import validationEN from './locales/en/validation.json' with { type: "json" };
import plansEN from './locales/en/plans.json' with { type: "json" };
import dashboardEN from './locales/en/dashboard.json' with { type: "json" };
import processEN from './locales/en/process.json' with { type: "json" };
import networkEN from './locales/en/network.json' with { type: "json" };
import grcEN from './locales/en/grc.json' with { type: "json" };

import commonES from './locales/es/common.json' with { type: "json" };
import authES from './locales/es/auth.json' with { type: "json" };
import diagramES from './locales/es/diagram.json' with { type: "json" };
import genogramES from './locales/es/genogram.json' with { type: "json" };
import errorsES from './locales/es/errors.json' with { type: "json" };
import validationES from './locales/es/validation.json' with { type: "json" };
import plansES from './locales/es/plans.json' with { type: "json" };
import dashboardES from './locales/es/dashboard.json' with { type: "json" };

import commonPT from './locales/pt/common.json' with { type: "json" };
import authPT from './locales/pt/auth.json' with { type: "json" };
import diagramPT from './locales/pt/diagram.json' with { type: "json" };
import genogramPT from './locales/pt/genogram.json' with { type: "json" };
import errorsPT from './locales/pt/errors.json' with { type: "json" };
import validationPT from './locales/pt/validation.json' with { type: "json" };
import plansPT from './locales/pt/plans.json' with { type: "json" };
import dashboardPT from './locales/pt/dashboard.json' with { type: "json" };

import commonDE from './locales/de/common.json' with { type: "json" };
import authDE from './locales/de/auth.json' with { type: "json" };
import diagramDE from './locales/de/diagram.json' with { type: "json" };
import genogramDE from './locales/de/genogram.json' with { type: "json" };
import errorsDE from './locales/de/errors.json' with { type: "json" };
import validationDE from './locales/de/validation.json' with { type: "json" };
import plansDE from './locales/de/plans.json' with { type: "json" };
import dashboardDE from './locales/de/dashboard.json' with { type: "json" };

import commonFR from './locales/fr/common.json' with { type: "json" };
import authFR from './locales/fr/auth.json' with { type: "json" };
import diagramFR from './locales/fr/diagram.json' with { type: "json" };
import genogramFR from './locales/fr/genogram.json' with { type: "json" };
import errorsFR from './locales/fr/errors.json' with { type: "json" };
import validationFR from './locales/fr/validation.json' with { type: "json" };
import plansFR from './locales/fr/plans.json' with { type: "json" };
import dashboardFR from './locales/fr/dashboard.json' with { type: "json" };

import commonAR from './locales/ar/common.json' with { type: "json" };
import authAR from './locales/ar/auth.json' with { type: "json" };
import diagramAR from './locales/ar/diagram.json' with { type: "json" };
import genogramAR from './locales/ar/genogram.json' with { type: "json" };
import errorsAR from './locales/ar/errors.json' with { type: "json" };
import validationAR from './locales/ar/validation.json' with { type: "json" };
import plansAR from './locales/ar/plans.json' with { type: "json" };
import dashboardAR from './locales/ar/dashboard.json' with { type: "json" };

import commonEL from './locales/el/common.json' with { type: "json" };
import authEL from './locales/el/auth.json' with { type: "json" };
import diagramEL from './locales/el/diagram.json' with { type: "json" };
import genogramEL from './locales/el/genogram.json' with { type: "json" };
import errorsEL from './locales/el/errors.json' with { type: "json" };
import validationEL from './locales/el/validation.json' with { type: "json" };
import plansEL from './locales/el/plans.json' with { type: "json" };
import dashboardEL from './locales/el/dashboard.json' with { type: "json" };

import commonHE from './locales/he/common.json' with { type: "json" };
import authHE from './locales/he/auth.json' with { type: "json" };
import diagramHE from './locales/he/diagram.json' with { type: "json" };
import genogramHE from './locales/he/genogram.json' with { type: "json" };
import errorsHE from './locales/he/errors.json' with { type: "json" };
import validationHE from './locales/he/validation.json' with { type: "json" };
import plansHE from './locales/he/plans.json' with { type: "json" };
import dashboardHE from './locales/he/dashboard.json' with { type: "json" };

import commonID from './locales/id/common.json' with { type: "json" };
import authID from './locales/id/auth.json' with { type: "json" };
import diagramID from './locales/id/diagram.json' with { type: "json" };
import genogramID from './locales/id/genogram.json' with { type: "json" };
import errorsID from './locales/id/errors.json' with { type: "json" };
import validationID from './locales/id/validation.json' with { type: "json" };
import plansID from './locales/id/plans.json' with { type: "json" };
import dashboardID from './locales/id/dashboard.json' with { type: "json" };

import commonIT from './locales/it/common.json' with { type: "json" };
import authIT from './locales/it/auth.json' with { type: "json" };
import diagramIT from './locales/it/diagram.json' with { type: "json" };
import genogramIT from './locales/it/genogram.json' with { type: "json" };
import errorsIT from './locales/it/errors.json' with { type: "json" };
import validationIT from './locales/it/validation.json' with { type: "json" };
import plansIT from './locales/it/plans.json' with { type: "json" };
import dashboardIT from './locales/it/dashboard.json' with { type: "json" };

import commonJA from './locales/ja/common.json' with { type: "json" };
import authJA from './locales/ja/auth.json' with { type: "json" };
import diagramJA from './locales/ja/diagram.json' with { type: "json" };
import genogramJA from './locales/ja/genogram.json' with { type: "json" };
import errorsJA from './locales/ja/errors.json' with { type: "json" };
import validationJA from './locales/ja/validation.json' with { type: "json" };
import plansJA from './locales/ja/plans.json' with { type: "json" };
import dashboardJA from './locales/ja/dashboard.json' with { type: "json" };

import commonKO from './locales/ko/common.json' with { type: "json" };
import authKO from './locales/ko/auth.json' with { type: "json" };
import diagramKO from './locales/ko/diagram.json' with { type: "json" };
import genogramKO from './locales/ko/genogram.json' with { type: "json" };
import errorsKO from './locales/ko/errors.json' with { type: "json" };
import validationKO from './locales/ko/validation.json' with { type: "json" };
import plansKO from './locales/ko/plans.json' with { type: "json" };
import dashboardKO from './locales/ko/dashboard.json' with { type: "json" };

import commonMS from './locales/ms/common.json' with { type: "json" };
import authMS from './locales/ms/auth.json' with { type: "json" };
import diagramMS from './locales/ms/diagram.json' with { type: "json" };
import genogramMS from './locales/ms/genogram.json' with { type: "json" };
import errorsMS from './locales/ms/errors.json' with { type: "json" };
import validationMS from './locales/ms/validation.json' with { type: "json" };
import plansMS from './locales/ms/plans.json' with { type: "json" };
import dashboardMS from './locales/ms/dashboard.json' with { type: "json" };

import commonTA from './locales/ta/common.json' with { type: "json" };
import authTA from './locales/ta/auth.json' with { type: "json" };
import diagramTA from './locales/ta/diagram.json' with { type: "json" };
import genogramTA from './locales/ta/genogram.json' with { type: "json" };
import errorsTA from './locales/ta/errors.json' with { type: "json" };
import validationTA from './locales/ta/validation.json' with { type: "json" };
import plansTA from './locales/ta/plans.json' with { type: "json" };
import dashboardTA from './locales/ta/dashboard.json' with { type: "json" };

import commonNL from './locales/nl/common.json' with { type: "json" };
import authNL from './locales/nl/auth.json' with { type: "json" };
import diagramNL from './locales/nl/diagram.json' with { type: "json" };
import genogramNL from './locales/nl/genogram.json' with { type: "json" };
import errorsNL from './locales/nl/errors.json' with { type: "json" };
import validationNL from './locales/nl/validation.json' with { type: "json" };
import plansNL from './locales/nl/plans.json' with { type: "json" };
import dashboardNL from './locales/nl/dashboard.json' with { type: "json" };

import commonNO from './locales/no/common.json' with { type: "json" };
import authNO from './locales/no/auth.json' with { type: "json" };
import diagramNO from './locales/no/diagram.json' with { type: "json" };
import genogramNO from './locales/no/genogram.json' with { type: "json" };
import errorsNO from './locales/no/errors.json' with { type: "json" };
import validationNO from './locales/no/validation.json' with { type: "json" };
import plansNO from './locales/no/plans.json' with { type: "json" };
import dashboardNO from './locales/no/dashboard.json' with { type: "json" };

import commonPL from './locales/pl/common.json' with { type: "json" };
import authPL from './locales/pl/auth.json' with { type: "json" };
import diagramPL from './locales/pl/diagram.json' with { type: "json" };
import genogramPL from './locales/pl/genogram.json' with { type: "json" };
import errorsPL from './locales/pl/errors.json' with { type: "json" };
import validationPL from './locales/pl/validation.json' with { type: "json" };
import plansPL from './locales/pl/plans.json' with { type: "json" };
import dashboardPL from './locales/pl/dashboard.json' with { type: "json" };

import commonRU from './locales/ru/common.json' with { type: "json" };
import authRU from './locales/ru/auth.json' with { type: "json" };
import diagramRU from './locales/ru/diagram.json' with { type: "json" };
import genogramRU from './locales/ru/genogram.json' with { type: "json" };
import errorsRU from './locales/ru/errors.json' with { type: "json" };
import validationRU from './locales/ru/validation.json' with { type: "json" };
import plansRU from './locales/ru/plans.json' with { type: "json" };
import dashboardRU from './locales/ru/dashboard.json' with { type: "json" };

import commonSI from './locales/si/common.json' with { type: "json" };
import authSI from './locales/si/auth.json' with { type: "json" };
import diagramSI from './locales/si/diagram.json' with { type: "json" };
import genogramSI from './locales/si/genogram.json' with { type: "json" };
import errorsSI from './locales/si/errors.json' with { type: "json" };
import validationSI from './locales/si/validation.json' with { type: "json" };
import plansSI from './locales/si/plans.json' with { type: "json" };
import dashboardSI from './locales/si/dashboard.json' with { type: "json" };

import commonTR from './locales/tr/common.json' with { type: "json" };
import authTR from './locales/tr/auth.json' with { type: "json" };
import diagramTR from './locales/tr/diagram.json' with { type: "json" };
import genogramTR from './locales/tr/genogram.json' with { type: "json" };
import errorsTR from './locales/tr/errors.json' with { type: "json" };
import validationTR from './locales/tr/validation.json' with { type: "json" };
import plansTR from './locales/tr/plans.json' with { type: "json" };
import dashboardTR from './locales/tr/dashboard.json' with { type: "json" };

import commonUK from './locales/uk/common.json' with { type: "json" };
import authUK from './locales/uk/auth.json' with { type: "json" };
import diagramUK from './locales/uk/diagram.json' with { type: "json" };
import genogramUK from './locales/uk/genogram.json' with { type: "json" };
import errorsUK from './locales/uk/errors.json' with { type: "json" };
import validationUK from './locales/uk/validation.json' with { type: "json" };
import plansUK from './locales/uk/plans.json' with { type: "json" };
import dashboardUK from './locales/uk/dashboard.json' with { type: "json" };

import commonVI from './locales/vi/common.json' with { type: "json" };
import authVI from './locales/vi/auth.json' with { type: "json" };
import diagramVI from './locales/vi/diagram.json' with { type: "json" };
import genogramVI from './locales/vi/genogram.json' with { type: "json" };
import errorsVI from './locales/vi/errors.json' with { type: "json" };
import validationVI from './locales/vi/validation.json' with { type: "json" };
import plansVI from './locales/vi/plans.json' with { type: "json" };
import dashboardVI from './locales/vi/dashboard.json' with { type: "json" };

import commonZH from './locales/zh/common.json' with { type: "json" };
import authZH from './locales/zh/auth.json' with { type: "json" };
import diagramZH from './locales/zh/diagram.json' with { type: "json" };
import genogramZH from './locales/zh/genogram.json' with { type: "json" };
import errorsZH from './locales/zh/errors.json' with { type: "json" };
import validationZH from './locales/zh/validation.json' with { type: "json" };
import plansZH from './locales/zh/plans.json' with { type: "json" };
import dashboardZH from './locales/zh/dashboard.json' with { type: "json" };

export const defaultNS = 'common';

export const resources = {
  en: {
    common: commonEN,
    auth: authEN,
    diagram: diagramEN,
    genogram: genogramEN,
    errors: errorsEN,
    validation: validationEN,
    plans: plansEN,
    dashboard: dashboardEN,
    process: processEN,
    network: networkEN,
    grc: grcEN,
  },
  es: {
    common: commonES,
    auth: authES,
    diagram: diagramES,
    genogram: genogramES,
    errors: errorsES,
    validation: validationES,
    plans: plansES,
    dashboard: dashboardES,
  },
  pt: {
    common: commonPT,
    auth: authPT,
    diagram: diagramPT,
    genogram: genogramPT,
    errors: errorsPT,
    validation: validationPT,
    plans: plansPT,
    dashboard: dashboardPT,
  },
  de: {
    common: commonDE,
    auth: authDE,
    diagram: diagramDE,
    genogram: genogramDE,
    errors: errorsDE,
    validation: validationDE,
    plans: plansDE,
    dashboard: dashboardDE,
  },
  fr: {
    common: commonFR,
    auth: authFR,
    diagram: diagramFR,
    genogram: genogramFR,
    errors: errorsFR,
    validation: validationFR,
    plans: plansFR,
    dashboard: dashboardFR,
  },
  ar: {
    common: commonAR,
    auth: authAR,
    diagram: diagramAR,
    genogram: genogramAR,
    errors: errorsAR,
    validation: validationAR,
    plans: plansAR,
    dashboard: dashboardAR,
  },
  el: {
    common: commonEL,
    auth: authEL,
    diagram: diagramEL,
    genogram: genogramEL,
    errors: errorsEL,
    validation: validationEL,
    plans: plansEL,
    dashboard: dashboardEL,
  },
  he: {
    common: commonHE,
    auth: authHE,
    diagram: diagramHE,
    genogram: genogramHE,
    errors: errorsHE,
    validation: validationHE,
    plans: plansHE,
    dashboard: dashboardHE,
  },
  id: {
    common: commonID,
    auth: authID,
    diagram: diagramID,
    genogram: genogramID,
    errors: errorsID,
    validation: validationID,
    plans: plansID,
    dashboard: dashboardID,
  },
  it: {
    common: commonIT,
    auth: authIT,
    diagram: diagramIT,
    genogram: genogramIT,
    errors: errorsIT,
    validation: validationIT,
    plans: plansIT,
    dashboard: dashboardIT,
  },
  ja: {
    common: commonJA,
    auth: authJA,
    diagram: diagramJA,
    genogram: genogramJA,
    errors: errorsJA,
    validation: validationJA,
    plans: plansJA,
    dashboard: dashboardJA,
  },
  ko: {
    common: commonKO,
    auth: authKO,
    diagram: diagramKO,
    genogram: genogramKO,
    errors: errorsKO,
    validation: validationKO,
    plans: plansKO,
    dashboard: dashboardKO,
  },
  ms: {
    common: commonMS,
    auth: authMS,
    diagram: diagramMS,
    genogram: genogramMS,
    errors: errorsMS,
    validation: validationMS,
    plans: plansMS,
    dashboard: dashboardMS,
  },
  ta: {
    common: commonTA,
    auth: authTA,
    diagram: diagramTA,
    genogram: genogramTA,
    errors: errorsTA,
    validation: validationTA,
    plans: plansTA,
    dashboard: dashboardTA,
  },
  nl: {
    common: commonNL,
    auth: authNL,
    diagram: diagramNL,
    genogram: genogramNL,
    errors: errorsNL,
    validation: validationNL,
    plans: plansNL,
    dashboard: dashboardNL,
  },
  no: {
    common: commonNO,
    auth: authNO,
    diagram: diagramNO,
    genogram: genogramNO,
    errors: errorsNO,
    validation: validationNO,
    plans: plansNO,
    dashboard: dashboardNO,
  },
  pl: {
    common: commonPL,
    auth: authPL,
    diagram: diagramPL,
    genogram: genogramPL,
    errors: errorsPL,
    validation: validationPL,
    plans: plansPL,
    dashboard: dashboardPL,
  },
  ru: {
    common: commonRU,
    auth: authRU,
    diagram: diagramRU,
    genogram: genogramRU,
    errors: errorsRU,
    validation: validationRU,
    plans: plansRU,
    dashboard: dashboardRU,
  },
  si: {
    common: commonSI,
    auth: authSI,
    diagram: diagramSI,
    genogram: genogramSI,
    errors: errorsSI,
    validation: validationSI,
    plans: plansSI,
    dashboard: dashboardSI,
  },
  tr: {
    common: commonTR,
    auth: authTR,
    diagram: diagramTR,
    genogram: genogramTR,
    errors: errorsTR,
    validation: validationTR,
    plans: plansTR,
    dashboard: dashboardTR,
  },
  uk: {
    common: commonUK,
    auth: authUK,
    diagram: diagramUK,
    genogram: genogramUK,
    errors: errorsUK,
    validation: validationUK,
    plans: plansUK,
    dashboard: dashboardUK,
  },
  vi: {
    common: commonVI,
    auth: authVI,
    diagram: diagramVI,
    genogram: genogramVI,
    errors: errorsVI,
    validation: validationVI,
    plans: plansVI,
    dashboard: dashboardVI,
  },
  zh: {
    common: commonZH,
    auth: authZH,
    diagram: diagramZH,
    genogram: genogramZH,
    errors: errorsZH,
    validation: validationZH,
    plans: plansZH,
    dashboard: dashboardZH,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'pt', 'de', 'fr', 'ar', 'el', 'he', 'id', 'it', 'ja', 'ko', 'ms', 'ta', 'nl', 'no', 'pl', 'ru', 'si', 'tr', 'uk', 'vi', 'zh'],

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['navigator'],
      caches: [],
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
